import { Link } from "react-router-dom";

const PrivacyPolicyPage = () => {
  return (
    <div
      className="min-h-screen bg-brand-background"
      data-testid="privacy-policy-page"
    >
      {/* Hero */}
      <section className="py-16 md:py-20 bg-brand-primary">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white">
            Privacy Policy
          </h1>
          <p className="text-white/70 mt-4">
            Ultimo aggiornamento: Dicembre 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="prose prose-lg max-w-none text-brand-foreground">
            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              1. Titolare del Trattamento
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              Il Titolare del trattamento dei dati è Metodo Contabile S.r.l.,
              con sede legale in Via Roma, 33100 Udine (UD), Italia. Per
              qualsiasi informazione relativa al trattamento dei dati personali,
              è possibile contattare il Titolare.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              2. Tipologie di Dati Raccolti
            </h2>
            <p className="text-brand-muted leading-relaxed mb-4">
              I dati personali raccolti da questo sito web includono:
            </p>
            <ul className="list-disc pl-6 text-brand-muted space-y-2 mb-6">
              <li>Dati di navigazione (indirizzo IP, browser, sistema operativo)</li>
              <li>Dati forniti volontariamente dall'utente (nome, email, telefono)</li>
              <li>Cookie tecnici e analitici</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              3. Finalità del Trattamento
            </h2>
            <p className="text-brand-muted leading-relaxed mb-4">
              I dati personali sono trattati per le seguenti finalità:
            </p>
            <ul className="list-disc pl-6 text-brand-muted space-y-2 mb-6">
              <li>Erogazione dei servizi richiesti dall'utente</li>
              <li>Risposta a richieste di informazioni</li>
              <li>Adempimento di obblighi legali e contrattuali</li>
              <li>Miglioramento dell'esperienza di navigazione</li>
              <li>Analisi statistiche anonime del traffico web</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              4. Base Giuridica del Trattamento
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              Il trattamento dei dati personali si basa su: consenso
              dell'interessato, esecuzione di un contratto, adempimento di
              obblighi legali, legittimo interesse del Titolare.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              5. Modalità di Trattamento
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              I dati personali sono trattati con strumenti automatizzati e non
              automatizzati, con logiche strettamente correlate alle finalità
              indicate e con l'adozione di adeguate misure di sicurezza per
              prevenire accessi non autorizzati, divulgazione, modifica o
              distruzione non autorizzata dei dati.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              6. Conservazione dei Dati
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              I dati personali saranno conservati per il tempo necessario al
              conseguimento delle finalità per le quali sono trattati, e
              comunque per un periodo non superiore a quanto previsto dalla
              normativa applicabile.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              7. Diritti dell'Interessato
            </h2>
            <p className="text-brand-muted leading-relaxed mb-4">
              Ai sensi degli artt. 15-22 del Regolamento UE 2016/679 (GDPR),
              l'interessato ha diritto di:
            </p>
            <ul className="list-disc pl-6 text-brand-muted space-y-2 mb-6">
              <li>Accedere ai propri dati personali</li>
              <li>Richiedere la rettifica o la cancellazione dei dati</li>
              <li>Richiedere la limitazione del trattamento</li>
              <li>Opporsi al trattamento</li>
              <li>Richiedere la portabilità dei dati</li>
              <li>Revocare il consenso in qualsiasi momento</li>
              <li>Proporre reclamo all'Autorità Garante</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              8. Cookie
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              Questo sito utilizza cookie tecnici e analitici. Per maggiori
              informazioni, consultare la nostra{" "}
              <Link
                to="/cookie-policy"
                className="text-brand-primary hover:underline"
              >
                Cookie Policy
              </Link>
              .
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              9. Modifiche alla Privacy Policy
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              Il Titolare si riserva il diritto di modificare questa Privacy
              Policy in qualsiasi momento. Le modifiche saranno pubblicate su
              questa pagina con indicazione della data di ultimo aggiornamento.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              10. Contatti
            </h2>
            <p className="text-brand-muted leading-relaxed">
              Per esercitare i diritti sopra indicati o per qualsiasi
              informazione relativa al trattamento dei dati personali, è
              possibile contattare il Titolare del trattamento presso:
            </p>
            <p className="text-brand-muted mt-4">
              <strong>Metodo Contabile S.r.l.</strong>
              <br />
              Via Umberto I, 28
              <br />
              33038 San Daniele del Friuli (UD)
              <br />
              P.IVA: 02030830307
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
